import { combineReducers } from 'redux';
import Loader from './Slice/Loader/LoaderSlice';
import error from './Slice/Error/ErrorSlice';
import Login from './Slice/Login/LoginSlice';
import Global from './Slice/Global/GlobalSlice';
import Prospect from './Slice/Prospect/ProspectSlice';
import CallCenter from './Slice/CallCenterList/CallCenterListSlice';
import Lead from './Slice/Lead/LeadSlice';
import LoginModule from './Slice/LoginModule/LoginModuleSlice';
import Bank from './Slice/Bank/BankSlice';
import Disburse from './Slice/Disburse/DisburseSlice';
import Rejected from './Slice/Rejected/RejectedSlice';
import Revenue from './Slice/Revenue/RevenueSlice';
import Payout from './Slice/Payout/PayoutSlice';
import Receive from './Slice/Receive/ReceiveSlice';
import Report from './Slice/Report/ReportSlice';
import Onboarding from './Slice/Onboarding/OnboardingSlice';
import Agreement from './Slice/Agreement/AgreementSlice';
import Policy from './Slice/Policy/PolicySlice';
import Journey from './Slice/Journey/JourneySlice';
import sales from './Slice/Sales/SalesSlice';
import user from './Slice/User/UserSlice';
import DataSource from './Slice/DataSource/DataSourceSlice';
import Customer from './Slice/Customer/CustomerSlice';
import Dashboard from './Slice/Dashboard/DashboardSlice';
import Payable from './Slice/Payable/PayableSlice';

const RootReducer = combineReducers({
  Loader,
  error, // error message
  Login,
  Global,
  Prospect,
  CallCenter,
  Lead,
  LoginModule,
  Bank,
  Disburse,
  Rejected,
  Revenue,
  Payout,
  Receive,
  Report,
  Onboarding,
  Agreement,
  Policy,
  Journey,
  sales,
  user,
  DataSource,
  Customer,
  Dashboard,
  Payable
});

export default RootReducer;
